import React from "react";
import {
  Heart,
  Bookmark,
  Copy,
  MessageCircle,
  UserPlus,
  CircleCheck,
  TriangleAlert,
  Award,
  Coins,
  Bell,
} from "lucide-react";

export const NotificationIcon = ({ type, className = "" }) => {
  const iconProps = { className: `w-5 h-5 ${className}` };

  switch (type) {
    case "POST_LIKED":
      return <Heart {...iconProps} className={`${iconProps.className} text-rose-500`} />;
    case "POST_SAVED":
      return <Bookmark {...iconProps} className={`${iconProps.className} text-blue-500`} />;
    case "POST_COPIED":
      return <Copy {...iconProps} className={`${iconProps.className} text-teal-500`} />;
    case "COMMENT_RECEIVED":
      return <MessageCircle {...iconProps} className={`${iconProps.className} text-indigo-500`} />;
    case "NEW_FOLLOWER":
      return <UserPlus {...iconProps} className={`${iconProps.className} text-green-500`} />;
    case "POST_APPROVED":
      return <CircleCheck {...iconProps} className={`${iconProps.className} text-emerald-500`} />;
    case "POST_REJECTED":
      return <TriangleAlert {...iconProps} className={`${iconProps.className} text-red-500`} />;
    case "BADGE_AWARDED":
      return <Award {...iconProps} className={`${iconProps.className} text-purple-500`} />;
    case "CREDIT_EARNED":
      return <Coins {...iconProps} className={`${iconProps.className} text-yellow-500`} />;
    default:
      return <Bell {...iconProps} className={`${iconProps.className} text-gray-400`} />;
  }
};
